import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { MdDeleteForever } from "react-icons/md";

/**
 * Shared delete / remove confirmation for dealers dashboard actions.
 * Rendered in a portal so the overlay is not clipped by dashboard overflow.
 */
function ConfirmDialog({
  open,
  title = "Are you sure?",
  message,
  confirmLabel = "Delete",
  cancelLabel = "Cancel",
  confirming = false,
  confirmingLabel,
  onConfirm,
  onCancel,
  danger = true,
}) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape" && !confirming) onCancel?.();
    };
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", onKey);
    };
  }, [open, confirming, onCancel]);

  if (!open || typeof document === "undefined") return null;

  return createPortal(
    <div
      className="dd-confirm"
      role="dialog"
      aria-modal="true"
      aria-labelledby="dd-confirm-title"
    >
      <button
        type="button"
        className="dd-confirm__backdrop"
        aria-label={cancelLabel}
        onClick={() => (!confirming ? onCancel?.() : null)}
      />
      <div className="dd-confirm__panel">
        <div className="dd-confirm__icon" aria-hidden>
          <MdDeleteForever size={22} />
        </div>
        <h3 id="dd-confirm-title">{title}</h3>
        {typeof message === "string" ? <p>{message}</p> : message}
        <div className="dd-confirm__actions">
          <button
            type="button"
            className="dd-confirm__btn dd-confirm__btn--ghost"
            onClick={onCancel}
            disabled={confirming}
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            className={`dd-confirm__btn ${
              danger ? "dd-confirm__btn--danger" : "dd-confirm__btn--primary"
            }`}
            onClick={onConfirm}
            disabled={confirming}
          >
            {confirming
              ? confirmingLabel || `${confirmLabel}…`
              : confirmLabel}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}

export default ConfirmDialog;
